export default {
  creditRequests: ({ creditRequests }) => creditRequests,
  creditReports: ({ creditReports }) => creditReports,
  total: ({ total }) => total,
  selected: ({ selected }) => selected,
  customers: ({ customers }) => customers,
};
